import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyPickupCompleted from "./component";
import { withRouter } from "react-router-dom";
import { fetchKavachBanner, fetchTokenProcessedDetails, setActiveTab } from "../post-inspection-diy/actions";
import { fetchBankOfferCoupons } from "../../../components/mobile/with-bank-offer-coupons/action";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse,
        priceBreakup,
        activeTab
    },
    user: {
        gaId,
        secureToken
    }
}) => ({
    inspectionResponse,
    priceBreakup,
    gaId,
    secureToken,
    activeTab
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchTokenProcessedDetailsConnect: fetchTokenProcessedDetails,
    fetchBankOfferCouponsConnect: fetchBankOfferCoupons,
    setActiveTabConnect: setActiveTab,
    fetchKavachBannerConnect: fetchKavachBanner
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyPickupCompleted));
